const dayjs = useDayjs();

export default defineNuxtPlugin((nuxtApp) => {
	const timeFrames = [
		{
			id: '1d',
			name: '24h'
		},
		{
			id: '7d',
			name: '7d'
		},
		{
			id: '30d',
			name: '30d'
		},
		{
			id: '90d',
			name: '90d'
		},
		{
			id: 'all',
			name: 'All'
		}
	]

	const iconNameService = [,
		'article',
		'tiktok',
		'youtube',
		'twitter',
		'telegram',
		'medium',
	];

	const nameService = [,
		'Article',
		'TikTok',
		'YouTube',
		'X (Twitter)',
		'Telegram',
		'Medium',
	];

	const slugNameService = [,
		'articles',
		'tiktok',
		'youtube',
		'x-twitter',
		'telegram',
		'medium',
	];

	const servicesTypes = [
		'1',
		'2',
		'3',
		'4',
		'5',
		'6',
	]

	const marketTypesInfo = {
		1: {
			name: 'Crypto',
			slug: 'crypto',
		},
		2: {
			name: 'NFT',
			slug: 'nft',
		},
	}

	const statusOrder = [
		{
			value: 0,
			label: 'Delivered',
			color: 'success'
		},
		{
			value: 1,
			label: 'Pending',
			color: 'processing'
		},
		{
			value: 2,
			label: 'Error',
			color: 'error'
		},
		{
			value: 3,
			label: 'Canceled',
			color: 'error'
		},
	]

	const dateLocaleMapping = {
		'en': 'DD/MM/YYYY',
		'tr': 'DD.MM.YYYY',
		'de': 'DD.MM.YYYY',
		'ru': 'DD.MM.YYYY',
		'ja': 'DD/MM/YYYY',
		'es-mx': 'DD/MM/YYYY',
		'pt-br': 'DD/MM/YYYY',
		'fr': 'DD/MM/YYYY',
	}

	const getUniqId = (length) => {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		for (let i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * characters.length));
		}
		return result;
	}

	const detectMobile = () => {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}

	const shortWallet = (address) => {
		return `${address.slice(0, 5)}...${address?.slice(-4)}`
    }

	const shortEtherscanLink = (link) => {
		const address = link.match(/.+\/([0-9a-z]+)/);

		return `${address[1].slice(0, 5)}...${address[1]?.slice(-5)}`
    }

	const formatCoins = (money) => {
		let price;

		if (money % 1 !== 0) {
			price = money.toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			})
		} else {
			price = money.toLocaleString('en-US', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			})
		}
		return price;
    }

	let timeout;
	const debounce = (fn, delay) => {
		return (...args) => {
			if (timeout) {
				clearTimeout(timeout);
			}

			timeout = setTimeout(() => {
				fn(...args);
			}, delay);
		};
	};

	const formatFollowers = (num) => {
		if (num) {
			if (num >= 1000000) {
				return (num / 1000000).toFixed(1) + 'M';
			} else if (num >= 100000) {
				return (num / 1000).toFixed(0) + 'K';
			} else if (num >= 1000) {
				return (num / 1000).toFixed(1) + 'K';
			} else {
				return num.toString();
			}
		} else {
			return '-';
		}
	}

	const diffDates = (date2, date1) => {
		date2 = dayjs(date2);
		date1 = date1 ? dayjs(date1) : dayjs();

		const diff = date1.diff(date2);

		if (diff < 60000) { // less minute
			return `${date1.diff(date2, 'second')}s`;
		} else if (diff < 3600000) { // less hour
			return `${date1.diff(date2, 'minute')}min`;
		} else if (diff < 86400000) { // less day
			return `${date1.diff(date2, 'hour')}h`;
		} else {
			return `${date1.diff(date2, 'day')}d`;
		}
	}

	const difference = (arr1, arr2) => arr1.filter(x => {
		return !arr2.find(item => item.id === x.id)
	})

	const differenceArray = (arr1, arr2) => arr1.filter(a => {
		return !arr2.find(b => b === a)
	})

	const differenceSets = (setA, setB) => {
		let _difference = new Set(setA);
		for (let elem of setB) {
			_difference.delete(elem);
		}
		return _difference;
	}

	const unionSets = (setA, setB) => {
		let _union = new Set(setA);
		for (let elem of setB) {
			_union.add(elem);
		}
		return _union;
	}

	const createMetaDescription = (htmlText) => {
		let text = htmlText.replace(/<[^>]*>/g, '');

		if (text.length > 160) {
			text = text.slice(0, 160);

			const lastSpaceIndex = text.lastIndexOf(' ');
			if (lastSpaceIndex > 0) {
				text = text.substring(0, lastSpaceIndex);
			}
		}

		return text;
	}

	return {
		provide: {
			helpers: {
				dateLocaleMapping,
				iconNameService,
				nameService,
				slugNameService,
				servicesTypes,
				marketTypesInfo,
				statusOrder,
				timeFrames,
				createMetaDescription,
				debounce,
				detectMobile,
				diffDates,
				difference,
				differenceArray,
				differenceSets,
				formatCoins,
				formatFollowers,
				getUniqId,
				shortEtherscanLink,
				shortWallet,
				unionSets,
			}
		}
	};
})
